// extracted by mini-css-extract-plugin
module.exports = {"container":"ColorSwatch_container__9Z1TW","swatch":"ColorSwatch_swatch__qKuK5"};